import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
// components
import { Typeform } from "..";
import { OnboardingActionType, toGenericOnboarding, } from "../../pages/OnboardingFlow/OnboardingFlow";
export const OnboardingTypeform = toGenericOnboarding(({ setIsNextDisabled, config, currentIndex = 0, handleClick, }) => {
    var _a, _b;
    return (_jsx(_Fragment, { children: ((_a = config[currentIndex]) === null || _a === void 0 ? void 0 : _a.formID) && (_jsx(Typeform, { formID: (_b = config === null || config === void 0 ? void 0 : config[0]) === null || _b === void 0 ? void 0 : _b.formID, onSubmit: () => handleClick === null || handleClick === void 0 ? void 0 : handleClick(OnboardingActionType.Next) })) }));
});
const Wrapper = styled.div `
  height: 100%;
  padding: ${(props) => props.theme.spacing[32]} 0;
`;
OnboardingTypeform.displayName = 'OnboardingTypeform';
export default toGenericOnboarding(OnboardingTypeform);
